import React from 'react';
import {
  WorkflowBar,
  WorkflowStep,
  WorkflowStepNumber,
  WorkflowStepLabel,
  WorkflowDivider,
} from '../imageCanvasStyles';

const STEPS = [
  { id: 'upload', label: 'Upload Image' },
  { id: 'edit', label: 'Edit Image' },
  { id: 'generate', label: 'Publish' },
];

const WorkflowIndicator = ({ theme, selectedTheme, currentStep }) => {
  const shared = { theme, $selectedTheme: selectedTheme };
  const currentIndex = STEPS.findIndex(({ id }) => id === currentStep);

  return (
    <WorkflowBar {...shared}>
      {STEPS.map((step, index) => {
        const isActive = step.id === currentStep;
        const isCompleted = currentIndex > index;
        return (
          <React.Fragment key={step.id}>
            <WorkflowStep {...shared} $active={isActive}>
              <WorkflowStepNumber {...shared} $active={isActive} $completed={isCompleted}>
                {isCompleted ? '✓' : index + 1}
              </WorkflowStepNumber>
              <WorkflowStepLabel {...shared} $active={isActive} $completed={isCompleted}>
                {step.label}
              </WorkflowStepLabel>
            </WorkflowStep>
            {index < STEPS.length - 1 && <WorkflowDivider {...shared} />}
          </React.Fragment>
        );
      })}
    </WorkflowBar>
  );
};

export { WorkflowIndicator };
